import React from 'react';
import { FaStar } from 'react-icons/fa';
const Rating = ({rating}) => {

    return (
        <div>
            {rating>=4.5? <div>
                <FaStar/>
<FaStar/>
<FaStar/>
<FaStar/>
<FaStar/>
            </div> : rating>=4?
            <div>
            <FaStar/>
<FaStar/>
<FaStar/>
<FaStar/>

        </div>
        :   rating>=3?
        <div>
        <FaStar/>
<FaStar/>
<FaStar/>


    </div>: rating>=2?
            <div>
            <FaStar/>
<FaStar/>



        </div> :  <div>
        
<FaStar/>



        </div>}
        </div>
    );
};

export default Rating;